module.exports = __webpack_public_path__ + "img/_0.6285bed2.png";